module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lo2qH"))).then(() => parcelRequire('3a9aZ'));